angular.module('Itao.IndicatorMap').filter('inArray', function ($filter) {
  'use strict';

  return function (list, arrayFilter, element) {
    if (arrayFilter) {
      return $filter('filter')(list, function (listItem) {
        return arrayFilter.indexOf(listItem[element]) > -1;
      });
    }
  };
});
